
import retry from '@/utils/retry';
import { MESSAGES } from '../uitls/messages';
import { notifyError } from '../uitls/notification-helper';
import redirect from '../uitls/redirect';
import eliteService from './../api/elite-service';

const getState = () => {
    return {
        accuracy: null,
        loading: false,
        accuracyError: false,
        loaderMessage: MESSAGES.LOADING_ACCURACY,
        secondsPerformed: 0,
        caloriesBurnt: 0,
        feedback: 0,
        error: null,
        feedbackText: null
    };
}
const state = getState();

const mutations = {
    setAccuracy(state, data) {
        state.accuracy = data.accuracy_score;
        state.secondsPerformed = data.timeSeconds ? data.timeSeconds : 0;
        state.caloriesBurnt = data.calories_burnt;
    },
    setLoading(state, loading) {
        state.loading = loading;
    },
    setAccuracyError(state, error) {
        state.accuracyError = error;
    },
    setFeedback(state, feedback) {
        state.feedback = feedback;
    },
    setLoaderMessage(state, message) {
        state.loaderMessage = message;
    },
    resetState(state) {
        Object.assign(state, getState());
    },
    setFeedbackText(state, event) {
        state.feedbackText = event.target.value;
    }
};

const getters = {

};

const actions = {
    async loadFeedback({ commit }, workoutData) {
        commit('setLoading', true);
        try {
            const data = await eliteService.getAccuracy(workoutData);
            commit('setAccuracy', data);
            commit('setLoading', false);
            return data;
        }
        catch (e) {
            retry(e).then(async _ => {
                const data = await eliteService.getAccuracy(workoutData);
                commit('setAccuracy', data);
                commit('setLoading', false);
                return data;
            }).catch(e => {
                redirect(e);
                commit('setLoading', false);
                commit('setAccuracyError', true);
                Promise.reject(e);
            });
        }
    },
    async sendFeedback({ commit, state }, sessionId) {
        commit('setLoading', true);
        commit('setLoaderMessage', MESSAGES.SAVING_FEEDBACK)
        try {
            await eliteService.sendFeedback(sessionId, state.feedback, state.feedbackText);
            commit('setLoading', false);
        }
        catch (e) {
            retry(e).then(async _ => {
                const data = await await eliteService.sendFeedback(sessionId, state.feedback, state.feedbackText);
                commit('setLoading', false);
                return data;
            }).catch(e => {
                redirect(e);
                commit('setLoading', false);
                notifyError('Your feedback cannot be saved. Please try again.')
                Promise.reject(e);
            });
        }
    }
}


export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}